import { AxiosResponse } from "axios"
import httpClient from "../axios/interceptors"
import { API } from "./endpoint"
import { handleResponseError } from "helpers/utils"
import {
  DistributeStockInput,
  GetLotBatchCodesWithStockInput,
  InventoryMovementInput,
  ResponseDepartmentStockOverview,
  ResponseDepartmentStore,
  ResponseDistributeDepartmentStock,
  ResponseEnsureDepartmentWarehouse,
  ResponseFactoryStore,
  ResponseInventoryMovements,
  ResponseListDepartmentMaster,
  ResponseListDepartmentWarehouses,
  ResponseLotBatchCodesWithStock,
} from "./interface"

export const listDepartmentMaster =
  async (): Promise<ResponseListDepartmentMaster> => {
    const data: AxiosResponse<ResponseListDepartmentMaster> = await httpClient
      .get(API.listDepartmentMaster)
      .catch((error) => handleResponseError(error))
    return data.data
  }

export const getFactoryStore = async (): Promise<ResponseFactoryStore> => {
  const data: AxiosResponse<ResponseFactoryStore> = await httpClient
    .get(API.getFactoryStore)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getDepartmentStore = async (
  departmentId: string
): Promise<ResponseDepartmentStore> => {
  const data: AxiosResponse<ResponseDepartmentStore> = await httpClient
    .get(`${API.getDepartmentStore}${departmentId}`)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getInventoryMovements = async (
  input: InventoryMovementInput
): Promise<ResponseInventoryMovements> => {
  const data: AxiosResponse<ResponseInventoryMovements> = await httpClient
    .post(API.getInventoryMovements, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getDepartmentStockOverview = async (
  factoryId: string
): Promise<ResponseDepartmentStockOverview> => {
  const data: AxiosResponse<ResponseDepartmentStockOverview> = await httpClient
    .get(`${API.getDepartmentStockOverview}${factoryId}/overview`)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const listDepartmentWarehouses = async (
  factoryId: string
): Promise<ResponseListDepartmentWarehouses> => {
  const data: AxiosResponse<ResponseListDepartmentWarehouses> = await httpClient
    .get(`${API.listDepartmentWarehouses}${factoryId}/warehouses`)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const ensureDepartmentWarehouse = async (
  departmentMasterId: string
): Promise<ResponseEnsureDepartmentWarehouse> => {
  const data: AxiosResponse<ResponseEnsureDepartmentWarehouse> =
    await httpClient
      .post(`${API.ensureDepartmentWarehouse}${departmentMasterId}`)
      .catch((error) => handleResponseError(error))
  return data.data
}

export const distributeDepartmentStock = async (
  input: DistributeStockInput
): Promise<ResponseDistributeDepartmentStock> => {
  const data: AxiosResponse<ResponseDistributeDepartmentStock> = await httpClient
    .post(API.distributeDepartmentStock, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getLotBatchCodesWithStock = async (
  input: GetLotBatchCodesWithStockInput
): Promise<ResponseLotBatchCodesWithStock> => {
  const data: AxiosResponse<ResponseLotBatchCodesWithStock> = await httpClient
    .post(API.getLotBatchCodesWithStock, input)
    .catch((error) => handleResponseError(error))
  return data.data
}
